import { render } from "./IncomeDetail.vue?vue&type=template&id=5a295d63&scoped=true"
import script from "./IncomeDetail.vue?vue&type=script&lang=js"
export * from "./IncomeDetail.vue?vue&type=script&lang=js"

import "./IncomeDetail.vue?vue&type=style&index=0&id=5a295d63&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a295d63"]])

export default __exports__